/**
 * Знак подтверждения — как в соцсетях: залитая розетка с галочкой внутри.
 *
 * Отдельный компонент, а не иконка из общего набора: все остальные иконки у
 * нас контурные в 1.5px, а этот знак обязан быть заливкой. Контурная галочка
 * в ряду с названием бренда читается как ещё один значок статуса, а не как
 * «это точно они».
 *
 * Два повода для знака, и они разные:
 * — brand: платформа подтвердила, кто стоит за акциями;
 * — prize: платформа посмотрела доказательство призового фонда.
 * Поэтому цвет один, а подпись всегда рядом — знак без объяснения
 * превращается в украшение.
 */
import type { CSSProperties } from 'react';

export function VerifiedMark({
  size = 14,
  title,
  className,
  style,
}: {
  size?: number;
  title?: string;
  className?: string;
  style?: CSSProperties;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      className={className}
      style={{ flex: 'none', display: 'inline-block', verticalAlign: '-2px', ...style }}
      role={title ? 'img' : undefined}
      aria-label={title}
      aria-hidden={title ? undefined : true}
    >
      {title ? <title>{title}</title> : null}
      <path d="M8.00 0.00L9.68 1.72L12.00 1.07L12.60 3.40L14.93 4.00L14.28 6.32L16.00 8.00L14.28 9.68L14.93 12.00L12.60 12.60L12.00 14.93L9.68 14.28L8.00 16.00L6.32 14.28L4.00 14.93L3.40 12.60L1.07 12.00L1.72 9.68L0.00 8.00L1.72 6.32L1.07 4.00L3.40 3.40L4.00 1.07L6.32 1.72Z" fill="currentColor" />
      <path
        d="M5.2 8.1 7 9.9l3.8-3.9"
        fill="none"
        stroke="#fff"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
